import { Box, colors, SxProps } from "@mui/material";
import ScrollbarPKG, { ScrollbarProps as MainScrollbarProps } from "react-scrollbars-custom";

interface ScrollbarProps extends Omit<MainScrollbarProps, 'ref'> {
    sx?: SxProps,
    autoHide?: boolean
}

export default function Scrollbar({ children, sx, ...props }: ScrollbarProps) {
    return <Box sx={{
        '& .ScrollbarsCustom-Wrapper': {
            inset: '0 !important',

        },
        '& .ScrollbarsCustom-Track': {
            right: 'unset !important',
            left: 0,
            height: '100% !important',
            top: '0 !important',
            width: '4px !important',
            background: `${colors.grey[300]} !important`,

            '& .ScrollbarsCustom-Thumb': {
                borderRadius: '0 !important',
                background: `${colors.grey[800]} !important`
            }
        },
        ...sx
    }} component={ScrollbarPKG} {...props} >
        {children}
    </Box>
}